import { z } from "zod";
import { makeGetRequest } from "../../utils";

type GetOperationLogsReportOptions = {
	from: string;
	to: string;
	page_size?: number;
	next_page_token?: string;
	category_type?:
	| "all"
	| "user"
	| "user_settings"
	| "account"
	| "billing"
	| "im"
	| "recording"
	| "phone_contacts"
	| "webinar"
	| "sub_account"
	| "role"
	| "zoom_rooms";
};

const OperationLogsSchema = z.object({
	time: z.string(),
	operator: z.string(),
	category_type: z.string(),
	action: z.string(),
	operation_detail: z.string(),
});

const GetOperationLogsReportResponseSchema = z
	.object({
		page_size: z.number(),
		next_page_token: z.string(),
		from: z.string(),
		to: z.string(),
		operation_logs: z.array(OperationLogsSchema),
	})
	.deepPartial();

type GetOperationLogsReportResponse = z.infer<
	typeof GetOperationLogsReportResponseSchema
>;

const getOperationLogsReport = async (
	token: string,
	options: GetOperationLogsReportOptions,
): Promise<GetOperationLogsReportResponse> => {
	const res = await makeGetRequest({
		token,
		pathList: ["v2", "videosdk", "report", "operationlogs"],
		options,
	});
	return GetOperationLogsReportResponseSchema.parse(res);
};

export const curriedGetOperationLogsReport = (token: string) => (
	options: GetOperationLogsReportOptions,
) => getOperationLogsReport(token, options);